var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"job"},[_c('v-container',[_c('div',{staticClass:"contentjob"}),_c('div',{staticClass:"box-job"},[_c('v-container',[_c('div',{staticClass:"title-box-job"},[_c('Placeholder')],1)])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }